import React, { useMemo } from 'react'
import clsx from 'clsx'
import { Swiper, SwiperSlide } from 'swiper/react'
import styles from './Carousel.module.scss'

type SwiperProps = React.ComponentProps<typeof Swiper>

export type SwiperSlideProps = {
  isActive: boolean
  isPrev: boolean
  isNext: boolean
  isVisible: boolean
  isDuplicate: boolean
}

export type CarouselComponentProps = SwiperProps & {
  className?: string
  classes?: {
    container?: string
  }
  children?: React.ReactNode
}

export const CarouselDots: React.FC<{
  classes?: {
    dots?: string
    dot?: string
    dotActive?: string
  }
  dataLength?: number
  loop?: boolean
  onClick?: (event: React.MouseEvent<HTMLLIElement, MouseEvent>, value: number) => void
  round?: boolean
  value?: number
}> = props => {
  const { classes, loop, dataLength, onClick, round, value } = props

  const CarouselDotsComponent = useMemo(() => {
    if (!dataLength) return undefined

    const CarouselDotsComponent: Array<any> = []

    for (let i = 0; i < dataLength; i++) {
      CarouselDotsComponent.push(
        <li
          key={i}
          className={clsx(
            styles.CarouselDot,
            round && styles.CarouselDotRound,
            onClick && 'cursor-pointer',
            classes?.dot,
            i === value && styles.CarouselDotActive,
            i === value && classes?.dotActive
          )}
          onClick={event => {
            onClick?.(event, i + (loop ? 1 : 0))
          }}
        ></li>
      )
    }

    return CarouselDotsComponent
  }, [classes, value, dataLength, loop, onClick, round])

  return <ul className={clsx(styles.CarouselDots, classes?.dots)}>{CarouselDotsComponent}</ul>
}

const CarouselComponent: React.FC<CarouselComponentProps> = props => {
  const { className, classes, ...restProps } = props
  return (
    <div className={clsx(styles.CarouselRoot, className)}>
      <Swiper {...restProps} className={classes?.container} />
    </div>
  )
}
export const CarouselItem = SwiperSlide

export default CarouselComponent
